import React, { useState } from "react";
import { useQuery, useQueryClient } from "react-query";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  getLedgerControl,
  checkLedgerControl,
  createYearLedgers,
} from "../../../../api/apiServices";
import toast, { Toaster } from "react-hot-toast";
import { format } from "date-fns";
import Loader from "../../../Common/Spinner/Loader";

const CreateLedgers = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/ledger_accounts";
  const [isProcessing, setIsProcessing] = useState(false);
  const [yearLedgerExist, setYearLedgerExist] = useState(false);
  const [canSubmit, setCanSubmit] = useState(false);
  const [payment_year, setPaymentYear] = useState("");
 const queryClient = useQueryClient();
  const year = new Date().getFullYear() - 5;
  const years = Array.from(new Array(20), (val, index) => index + year);

  const { data: ledgerControl } = useQuery(
    "ledgerControl",
    () => getLedgerControl(),
    {
      select: (data) => data.sort((a, b) => b.id - a.id),
    }
  );

  const handleYear = (e) => {
    e.preventDefault();
    const paymentYear = e.target.value;
    checkLedgerControl(paymentYear).then((res) => {
      if (!res.success) {
        toast.error(res.message, {
          duration: 5000,
          className: "toast-message",
        });
        setCanSubmit(false);
        return false;
      } 
    });

    const minDate = new Date(`${paymentYear}-01-01`);
    const today = new Date();
    const dateFormat = "yyyy-MM-dd";

    if (today < minDate) {
      toast.error(
        `Ledger Accounts for the year ${paymentYear} can only be created after ${format(
          minDate,
          dateFormat
        )}`,
        {
          duration: 5000,
          className: "toast-message",
        }
      );
      setCanSubmit(false);
      setPaymentYear(paymentYear);
      return false;
    }else{
		setCanSubmit(true);
		setPaymentYear(paymentYear);
		return true;
	}
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsProcessing(true);
    const data = {
      end_year: payment_year,
    };
    createYearLedgers(data).then((res) => {
      if (res.success) {
        toast.success(res.message, {
          duration: 5000,
          className: "toast-message",
        });
		queryClient.invalidateQueries("ledgerControl");
        setCanSubmit(false);
        setIsProcessing(false);
        setYearLedgerExist(true);
        setPaymentYear("");
      } else {
        toast.error(res.message, {
          duration: 5000,
          className: "toast-message",
        });
        setCanSubmit(false);
        setIsProcessing(false);
      }
    });
  };
  const handleExist = () => {
    setIsProcessing(false);
    setYearLedgerExist(false);
  };

  const handleCancel = () => {
    navigate(from, { replace: true });
  };

  let content;
  if (isProcessing) {
    content = (
      <div className="loader">
        <p>{`Creating ${payment_year} Ledger Accounts. Please wait...`}</p>
        <Loader />
      </div>
    );
  } else {
    content = (
      <>
        <div className="panel panel-default panel-br-4">
          <div className="panel-body">
            <form onSubmit={handleSubmit}>
              <div className="form-group row">
                <label
                  htmlFor="payment_code"
                  className="col-sm-2 col-form-label"
                >
                  Ledger Accounts Year
                </label>
                <div className="col-sm-6">
                  <select
                    type="text"
                    id="payment_year"
                    autoComplete="off"
                    style={{ textTransform: "uppercase" }}
                    onChange={handleYear}
                    required
                    value={payment_year}
                    name="payment_year"
                    className="form-control"
                  >
                    <option className="form-control">Select Year</option>
                    {years.map((year, index) => (
                      <option value={year} key={`year${index}`}>
                        {year}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {!yearLedgerExist ? (
                <div className="panel-footer">
                  <div className="form-group row">
                    <div className="col-sm-1">
                      <button
                        type="submit"
                        className="btn btn-danger"
                        onClick={handleExist}
                      >
                        Cancel
                      </button>
                    </div>
                    <div className="col-sm-1">
                      <button
                        type="submit"
                        className="btn btn-success"
                        disabled={!canSubmit}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="panel-footer">
                  <div className="form-group row">
                    <div className="col-sm-1">
                      <button
                        type="submit"
                        className="btn btn-danger"
                        onClick={handleCancel}
                      >
                        Cancel
                      </button>
                    </div>
                    <div className="col-sm-1">
                      <button
                        type="submit"
                        className="btn btn-success"
                        disabled={!canSubmit}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </form>
          </div>
        </div>

        {yearLedgerExist && (
          <div className="table-responsive lg">
            <table className="table table-borderless table-striped">
              <thead>
                <tr>
                  <th style={{ textAlign: "center" }}>#</th>
                  <th style={{ textAlign: "center" }}>Year</th>
                  <th style={{ textAlign: "center" }}>Date Created</th>
                  <th style={{ textAlign: "center" }}>Date Updated</th>
                </tr>
              </thead>
              <tbody>
                {ledgerControl?.map((control, index) => (
                  <tr key={control.id}>
                    <td style={{ textAlign: "center" }}>{index + 1}</td>
                    <td style={{ textAlign: "center" }}>{control.year}</td>
                    <td style={{ textAlign: "center" }}>{control.createdAt}</td>
                    <td style={{ textAlign: "center" }}>{control.updatedAt}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </>
    );
  }

  return (
    <>
      <section className="content-header">
        <Toaster toastOptions={{ position: "top-center" }} />
        <h1>Create Ledger Accounts</h1>
      </section>
      <section className="content">
        <div className="box">
          <div className="box-body">
            <div className="panel panel-default panel-br-4">
              <div className="panel-heading">
                <div className="row">
                  <div className="col-sm-12">
                    <h4 className="panel-title"></h4>
                  </div>
                </div>
              </div>
              <div className="panel-body"> {content}</div>
              {/* <div className="panel-body"> {ledgControl}</div> */}
              <div className="panel-footer"></div>
            </div>
          </div>
          <div className="box-footer"></div>
        </div>
      </section>
    </>
  );
};

export default CreateLedgers;
